import * as types from "../constants/ecpProjectsConstants"

const initialState = {
    isModal: false,
    isConfirmationModal: {
        modal: false,
        id: null,
        action: null
    },
    tab: "my-projects",
    page: 1,
    projectID: null,
}

export default function ecpProjectsReducer(state=initialState, action) {
    switch(action.type) {
        case types.ECP_PROJECTS_IS_MODAL:
            return {
                ...state,
                isModal: action.payload.isModal,
                isConfirmationModal: state.isConfirmationModal,
                tab: state.tab,
                page: state.page,
                projectID: state.projectID,
            }
        case types.ECP_PROJECTS_IS_CONFIRMATION_MODAL:
            return {
                ...state,
                isModal: state.isModal,
                isConfirmationModal: action.payload.isConfirmationModal,
                tab: state.tab,
                page: state.page,
                projectID: state.projectID,
            }
        case types.ECP_PROJECTS_SET_TAB:
            return {
                ...state,
                isModal: state.isModal,
                isConfirmationModal: state.isConfirmationModal,
                tab: action.payload.tab,
                page: 1,
                projectID: state.projectID,
            }
        case types.ECP_PROJECTS_SET_PAGE:
            return {
                ...state,
                isModal: state.isModal,
                isConfirmationModal: state.isConfirmationModal,
                tab: state.tab,
                page: action.payload.page,
                projectID: state.projectID,
            }
        case types.SET_ECP_PROJECT_ID:
            return {
                ...state,
                isModal: state.isModal,
                isConfirmationModal: state.isConfirmationModal,
                tab: state.tab,
                page: state.page,
                projectID: action.payload.projectID,
            }
        case types.CLEAN_ECP_PROJECTS_CONTEXT:
            return initialState
        default:
            return state
    }
}